import { render, staticRenderFns } from "./Skill.vue?vue&type=template&id=8cb66922&scoped=true"
import script from "./Skill.vue?vue&type=script&lang=js"
export * from "./Skill.vue?vue&type=script&lang=js"
import style1 from "./Skill.vue?vue&type=style&index=1&id=8cb66922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb66922",
  null
  
)

export default component.exports